import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import hazardousGoodsImg from "../../../../assets/imgs/services/nationals/hazardous-goods.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import "../shared-css/national-global-styles.css";
import "./hazardous-goods.css";
import NationalDescription from "../../../../components/national-description/national-description";
import courier1Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier1.svg";
import courier2Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier2.svg";
import condiciones02Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg";
import highvalue3Icon from "../../../../assets/imgs/services/nationals/highvalue-icons/highvalue3.svg";

function HazardousGoods() {
  const [tHazardousGoods] = useTranslation("hazardousGoodsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idHazardousGoods = "d5593ad8-15cd-4168-90d9-27ed9b86cfb9";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);
  const nonApplicableIcons = [courier2Icon, courier1Icon];
  const additionalConditionIcons = [condiciones02Icon, highvalue3Icon];

  const getListItems = (translationPath) => {
    const list = tHazardousGoods(`${translationPath}.items`, {
      returnObjects: true,
    });

    if (Array.isArray(list) && list.length > 0) {
      return list;
    }

    const legacyItems = [1, 2, 3]
      .map((index) => tHazardousGoods(`${translationPath}.item${index}`))
      .filter(
        (item) => item && !item.includes(`${translationPath}.item`)
      );

    return legacyItems;
  };

  const nonApplicableCharges = getListItems("non-applicable-charges");
  const additionalConditions = getListItems("additional-conditions");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[11]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[11]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHazardousGoods}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Por favor, consulte la sección Restricciones para obtener la lista de mercancías prohibidas para su transporte con Aeroméxico Cargo.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Contemple tiempo adicional si su embarque contiene mercancías peligrosas.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Para mayores informes, contacte a su ejecutivo de ventas de Aeroméxico Cargo.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
              ],
            })
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Please refer to the Restrictions section for the list of goods prohibited for transport with Aeromexico Cargo.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Allow additional time if your shipment contains dangerous goods.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "For more information, contact your Aeromexico Cargo sales executive.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
              ],
            })
          );
        }
      })
      .catch((error) => {
        console.error(error);
        const lng = localStorage.getItem("lng") || "es";
        if (lng === "es") {
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Por favor, consulte la sección Restricciones para obtener la lista de mercancías prohibidas para su transporte con Aeroméxico Cargo.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Contemple tiempo adicional si su embarque contiene mercancías peligrosas.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Para mayores informes, contacte a su ejecutivo de ventas de Aeroméxico Cargo.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
              ],
            })
          );
        } else {
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Please refer to the Restrictions section for the list of goods prohibited for transport with Aeromexico Cargo.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Allow additional time if your shipment contains dangerous goods.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "For more information, contact your Aeromexico Cargo sales executive.",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
              ],
            })
          );
        }
      });
  }, []);

  const renderInfoItems = (items, icons) => {
    if (!Array.isArray(items)) return null;

    return items.map((item, index) => (
      <div className="item" key={`${item}-${index}`}>
        <div className="icon">
          <img src={icons[index % icons.length]} alt="" aria-hidden="true" />
        </div>
        <p>{item}</p>
      </div>
    ));
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("mercancíaPeligrosa.title")}</title>
        <meta
          name="description"
          content={tSMetaData("mercancíaPeligrosa.description")}
        />
      </Helmet>
      <ImageHeader imgBackground={hazardousGoodsImg} />
      <div className="info-national-content">
        <NationalDescription
          title={tHazardousGoods("header.title")}
          description={textDescription ? JSON.parse(textDescription) : ""}
          contactSales={tHazardousGoods("header.contact-sales")}
          contactProductID="btnContactHazardous"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tHazardousGoods("header.prepare-charge")}</h3>
          </div>
          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tHazardousGoods("accordion-1.title")}
              content={accordion1 ? JSON.parse(accordion1) : "{}"}
            />
            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tHazardousGoods("accordion-2.title")}
              content={accordion2 ? JSON.parse(accordion2) : "{}"}
            />
            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tHazardousGoods("accordion-3.title")}
              content={accordion3 ? JSON.parse(accordion3) : {}}
            />
          </div>
        </div>
      </div>
      <div className="more-info-content hazardous-more-info">
        <div className="more-info-box">
          <h5>{tHazardousGoods("non-applicable-charges.title")}</h5>
          <div className="icons">
            {renderInfoItems(nonApplicableCharges, nonApplicableIcons)}
          </div>
        </div>
        <div className="more-info-box">
          <h5>{tHazardousGoods("additional-conditions.title")}</h5>
          <div className="icons">
            {renderInfoItems(additionalConditions, additionalConditionIcons)}
          </div>
        </div>
      </div>
    </>
  );
}

export default HazardousGoods;
